import { createSlice } from "@reduxjs/toolkit";

const themeModel = {
    id: '',
    name: '',
    lang: '',
    logoPath: '',
    isTabletPortraitOrMobile: false,
    subTheme: '',
};

export const themeSlice = createSlice({
  name: "theme",
  initialState: themeModel,
  reducers: {
    setTheme: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    }
  },
});

// Action creators are generated for each case reducer function
export const { setTheme } = themeSlice.actions;

export default themeSlice.reducer;
